import { Icon } from '@iconify/react/dist/iconify.js';
import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import Pagination from './child/Pagination';

const UsersListLayer = ({ data }) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const currentPage = Number(searchParams.get('page')) || 1;

    const handlePageChange = page => {
        setSearchParams({
            ...Object.fromEntries(searchParams),
            page,
        });
    };


    function handleChangeStatus(e) {
        const currentParams = Object.fromEntries(searchParams);
        const newStatus = e.target.value;

        if (newStatus === 'true' || newStatus === 'false') {
            currentParams.status = newStatus;
        } else {
            delete currentParams.status; // Remove o parâmetro da URL
        };

        setSearchParams(currentParams);
    };

    function handleChangeName(e) {
        const currentParams = Object.fromEntries(searchParams);

        if (e.target.value.trim().length > 0) {
            currentParams.nome = e.target.value;
        } else {
            delete currentParams.nome;
        }
        setSearchParams(currentParams);
    };
    function handleClearFilters() {
        setSearchParams({});
    };

    

    return (
        <div className="card h-100 p-0 radius-12">
            <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
                <div className="d-flex align-items-center flex-wrap gap-3">
                    
                    <div className="d-flex flex-wrap align-items-center gap-3">
                        <select className="form-select form-select-sm w-auto" onChange={handleChangeStatus} value={searchParams.get('status') || ''}>
                            <option value="">Todos os status</option>
                            <option value={true}>Ativo</option>
                            <option value={false}>Inativo</option>
                        </select>
                    </div>
                    <form className="navbar-search">
                        <input type="text" className="bg-base h-40-px w-auto" onChange={handleChangeName} name="search" placeholder="Buscar usuário" value={searchParams.get('nome') || ''} />
                        <Icon icon="ion:search-outline" className="icon" />
                    </form>
                    <button type="button" className="btn btn-outline-neutral-500 btn-sm" onClick={handleClearFilters}>
                        Limpar
                    </button>
                   
                </div>
                <Link to="add" className="btn btn-primary-600 btn-sm">
                    <Icon icon="ic:baseline-plus" className="icon text-xl line-height-1" />
                    Novo usuário
                </Link>
            </div>
            <div className="card-body p-24">
                <div className="table-responsive scroll-sm">
                    <table className="table bordered-table sm-table mb-0">
                        <thead>
                            <tr>
                                <th scope="col">Id</th>
                                <th scope="col">Nome</th>
                                <th scope="col">Email</th>
                                <th scope="col">Status</th>
                                <th scope="col"> </th>
                            </tr>
                        </thead>
                        <tbody>
                            {Boolean(data) &&
                                data?.usuario?.map(user => (
                                    <tr>
                                       
                                        <td>{user.id}</td>
                                        <td>
                                            <div className="d-flex align-items-center">
                                               
                                                <div className="flex-grow-1">
                                                    <span className="text-md mb-0 fw-normal text-secondary-light">{user.nome}</span>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <span className="text-md mb-0 fw-normal text-secondary-light">{user.email}</span>
                                        </td>
                                        <td>
                                            {(() => {
                                                const isActive = user.status === true;
                                                const style = isActive ? 'success' : 'danger';
                                                const text = isActive ? 'Ativo' : 'Inativo';

                                                return (
                                                    <span
                                                        className={`bg-${style}-focus rounded-pill text-sm text-${style}-main fw-medium px-24 py-4`}
                                                    >
                                                        {text}
                                                    </span>
                                                );
                                            })()}
                                        </td>
                                        <td className="text-center">
                                            <div className="d-flex align-items-center gap-10 justify-content-center">
                                                
                                                <Link
                                                    to={`${user.id}`}
                                                    className="bg-success-focus text-success-600 bg-hover-success-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                >
                                                    <Icon icon="lucide:edit" className="menu-icon" />
                                                </Link>
                                               
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>
                </div>
                <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mt-24">
                    <span> Mostrando {data?.itens_per_page} de{' '} {data?.total}  {data?.itens_per_page > 1 ? "itens" : "item"}  </span>
                    {data?.pages > 1 && <Pagination page={currentPage} pages={data?.pages} onPageChange={handlePageChange}  />}
                </div>
            </div>
        </div>
    );
};

export default UsersListLayer;
